import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';

import { TrustlyStatusValue } from '../utils/trustly-status';
import { FraudAnalysisMessage } from './FraudAnalysisMessage';

interface TrustlyStatusMessageProps {
    status: TrustlyStatusValue;
}

type ErrorKeys =
    | 'wallet.trustly_status_fraud_analysis'
    | 'wallet.trustly_status_insufficient_funds'
    | 'wallet.trustly_status_invalid_account';

export const TrustlyStatusMessage = ({ status }: TrustlyStatusMessageProps) => {
    const { t } = useTranslation(['error', 'wallet']);
    const translationKey = `wallet.trustly_status_${status}` as ErrorKeys;

    if (status === TrustlyStatusValue.FRAUD_ANALYSIS) {
        return <FraudAnalysisMessage />;
    }

    return (
        <Text textAlign="center" color={ds.colorToken.text.secondary} variant="bodyMedium" mt="s8">
            {t(translationKey)}
        </Text>
    );
};
